import React, { useState } from "react";
import { useIsTouch } from "../lib/useIsTouch";
import { usePrefersReducedMotion } from "../lib/usePrefersReducedMotion";

/*
 * FlippingCard — 3D flip on hover (desktop) or tap (touch). Adapted to JS from a
 * 21st.dev component; brand-agnostic, pass frontContent / backContent.
 */
export function FlippingCard({
  className = "",
  frontContent,
  backContent,
  height = 300,
  testId,
}) {
  const [flipped, setFlipped] = useState(false);
  const touch = useIsTouch();
  const reduced = usePrefersReducedMotion();

  return (
    <div
      data-testid={testId}
      className="group/flip h-full w-full [perspective:1200px]"
      onClick={touch ? () => setFlipped((f) => !f) : undefined}
      role={touch ? "button" : undefined}
      tabIndex={touch ? 0 : undefined}
      onKeyDown={
        touch
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setFlipped((f) => !f);
              }
            }
          : undefined
      }
    >
      <div
        className={`relative h-full w-full rounded-[14px] [transform-style:preserve-3d] ${
          reduced ? "" : "transition-transform duration-700"
        } group-hover/flip:[transform:rotateY(180deg)] ${
          flipped ? "[transform:rotateY(180deg)]" : ""
        } ${className}`}
        style={{ minHeight: height }}
      >
        {/* Front */}
        <div className="absolute inset-0 h-full w-full overflow-hidden rounded-[inherit] [backface-visibility:hidden] [transform:rotateY(0deg)]">
          {frontContent}
        </div>
        {/* Back */}
        <div className="absolute inset-0 h-full w-full overflow-hidden rounded-[inherit] [backface-visibility:hidden] [transform:rotateY(180deg)]">
          {backContent}
        </div>
      </div>
    </div>
  );
}
